import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const getPathFriendlyNameSelectorFactory = (getProperNameSelector) => createSelector(getProperNameSelector, (getWalletAccountProperName) => (walletAccount, { maxLength } = {}) => getWalletAccountProperName(walletAccount, { maxLength })
    .replace(/[^\da-z-]/giu, '_')
    .toLowerCase());
const getPathFriendlyNameSelectorDefinition = defineSelectorFactory({
    id: 'getPathFriendlyName',
    selectorFactory: getPathFriendlyNameSelectorFactory,
    dependencies: [
        { selector: 'getProperName' },
    ],
});
export default getPathFriendlyNameSelectorDefinition;
